import LocationOn from "@mui/icons-material/LocationOn";
import Message from "@mui/icons-material/Message";
import { CallEnd } from "@mui/icons-material";

export const contactUsMetaData = [
  {
    icon: <LocationOn className="text-fulvous" />,
    title: "Near NTPC Thermal Power, Harchnda Road Railway Crossing Kanti",
    subText: "Muzaffarpur, Bihar 843109",
  },
  {
    icon: <Message className="text-fulvous" />,
    title: "help@govahan.com",
    subText: "careers@govahan.com",
  },
  {
    icon: <CallEnd className="text-fulvous" />,
    title: "(+91) 840-917-2925",
    subText: "",
  },
];
